// QR code rendering, entirely local (no third-party service), so it works
// offline and on a local network with no internet access. Ported from
// zero-kami. Always black on white: a colored QR code loses contrast and
// scans less reliably with a phone camera.

import qrcode from 'qrcode-generator';

/** Draw a scalable SVG QR code for `text` into `container`, replacing its contents. */
export function renderQrCode(container, text) {
  const qr = qrcode(0, 'M'); // type 0 = size automatically, medium error correction
  qr.addData(text);
  qr.make();
  container.innerHTML = qr.createSvgTag({ cellSize: 4, margin: 2, scalable: true });
  const svg = container.querySelector('svg');
  if (svg) svg.setAttribute('class', 'share-qr-svg');
}
